import React from 'react';
import { Dropdown } from '../common/Dropdown';
import { DROPDOWN_POSITIONS } from '../../../constants';
import { getFlagCodeFromLanguage } from '../../../main';
import * as PropTypes from 'prop-types';
import Icon from '@iconify/react';
import iconChevronLeft from '@iconify-icons/mdi/chevron-left';
const LanguagesDropdown = (props) => {
  return (
    <Dropdown position={DROPDOWN_POSITIONS.CENTER} isOpen={props.isOpen}>
      {freedomeConfig.languages &&
        freedomeConfig.languages.map((language, index) => {
          const flag = `circle-flags:lang-${language.code}`;
          return (
            <div key={index}>
              <a href={language.url}>
                <div>
                  <span className="iconify" data-icon={flag}></span>
                </div>
                <div>{language.fullname}</div>
              </a>
            </div>
          );
        })}
      <div>
        <a
          href={void 0}
        >
          {' '}
          <Icon icon={iconChevronLeft} className="icon" />{' '}
          {app_main_wpml.back_to_menu}
        </a>
      </div>
    </Dropdown>
  );
};
LanguagesDropdown.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

LanguagesDropdown.defaultProps = {
  isOpen: false,
};

export default LanguagesDropdown;
